import React, { useContext, useEffect, useState } from 'react';
import { includes, prop } from 'ramda';

export const LAYOUT_AUTH = 'auth';
export const LAYOUT_SECURED = 'secured';
const defaultValue = {
  layout: LAYOUT_SECURED
};
const allowLayouts = ['auth', 'secured'];

const LayoutContext = React.createContext(defaultValue);

export const useLayoutContext = () => useContext(LayoutContext);

export const useInternalLayoutContext = () => {
  const [_layout, _setLayout] = useState(prop('layout', defaultValue));
  const setLayout = (layout) => {
    if (includes(layout, allowLayouts)) {
      _setLayout(layout);
    }
  };
  return {
    layout: _layout,
    setLayout
  };
};

export const useChangeLayout = () => {
  const { layout, setLayout } = useLayoutContext();
  const setLayoutToSecured = () => setLayout(LAYOUT_SECURED);
  const setLayoutToAuth = () => setLayout(LAYOUT_AUTH);

  return {
    layout,
    setLayoutToSecured,
    setLayoutToAuth
  };
};

export const useChangeLayoutToAuth = (params = { auto: true }) => {
  const auto = prop('auto', params);
  const { layout, setLayoutToSecured, setLayoutToAuth } = useChangeLayout();

  useEffect(() => {
    if (layout !== LAYOUT_AUTH && auto) {
      setLayoutToAuth();
    }
  }, [layout, auto]);

  return {
    setLayoutToSecured,
    setLayoutToAuth
  };
};

export const useChangeLayoutToSecured = (params = { auto: true }) => {
  const auto = prop('auto', params);
  const { layout, setLayoutToSecured, setLayoutToAuth } = useChangeLayout();

  useEffect(() => {
    if (layout !== LAYOUT_SECURED && auto) {
      setLayoutToSecured(LAYOUT_SECURED);
    }
  }, [layout, auto]);

  return {
    setLayoutToSecured,
    setLayoutToAuth
  };
};

export default LayoutContext;
